import { Capacitor, registerPlugin } from '@capacitor/core';

const TikTokEvents = registerPlugin('TikTokEvents');

// Zdarzenia do natywnego SDK TikToka — zasilaja schemat conversion value w SKAN (iOS)
// i normalna atrybucje na Androidzie. Na webie no-op: SDK istnieje tylko w buildach natywnych.
//
// Mapowanie na schemat SKAN:
//   Registration       -> coarse low
//   AchieveLevel       -> coarse medium (pierwszy cel dzienny)
//   UnlockAchievement  -> coarse medium (cel dzienny drugi dzien z rzedu)
//   Purchase           -> coarse high
//
// UWAGA: 2026-09-08 zamieniono nazwy AchieveLevel <-> UnlockAchievement (kampanie
// AEO leca pod „Achieve Level" = domkniety cel dzienny). Oba zdarzenia siedza w tym
// samym kubelku coarse (medium), wiec schemat SKAN sie nie zmienil — zmienila sie
// tylko etykieta. Dane w Events Managerze sprzed tej daty maja znaczenie odwrotne.
const track = async (eventName, properties = {}) => {
  if (!Capacitor.isNativePlatform()) return;

  try {
    await TikTokEvents.track({ eventName, properties });
  } catch (e) {
    console.warn(`TikTok: nie udalo sie wyslac zdarzenia ${eventName}`, e);
  }
};

// Zdarzenia cyklu zycia uzytkownika maja sens tylko raz. Flage stawiamy przed wyslaniem —
// przy blednym mostku wolimy zgubic zdarzenie niz zduplikowac je w schemacie CV.
const trackOnce = async (eventName, userId, properties = {}) => {
  if (!Capacitor.isNativePlatform() || !userId) return;

  const key = `tt_sent_${eventName}_${userId}`;
  if (localStorage.getItem(key)) return;
  localStorage.setItem(key, '1');

  await track(eventName, properties);
};

export const trackRegistration = (userId) => trackOnce('Registration', userId);

export const trackFirstDailyGoal = (userId) =>
  trackOnce('AchieveLevel', userId, { description: 'first_daily_goal', level: 1 });

export const trackSecondDayStreak = (userId) =>
  trackOnce('UnlockAchievement', userId, { description: 'daily_goal_streak_2' });

// iOS: od SDK 1.7 TikTok sam obserwuje transakcje StoreKit 1 ORAZ StoreKit 2
// (RevenueCat 5.x kupuje przez SK2) i loguje `Purchase` z value, currency i contents,
// pilnujac wlasnej deduplikacji po transaction_id. Wylaczyc tego z appki sie nie da —
// disablePaymentTracking() jest przy kazdym starcie nadpisywane przez global config
// TikToka (TikTokBusiness.m: paymentTrackingEnabled = globalConfigPaymentTrackingEnabled).
// Reczne zdarzenie policzyloby wiec zakup drugi raz, takze w schemacie CV.
// Android: SDK 1.5.0 ma auto-IAP domyslnie wylaczony (autoIapTrack=false), wiec tam
// wysylamy sami. Przy bumpie SDK Androida do >=1.6 sprawdz ten default — tam sie odwrocil.
export const trackPurchase = async ({ productId, value, currency }) => {
  if (Capacitor.getPlatform() === 'ios') return;

  await track('Purchase', {
    content_id: productId,
    content_type: 'product',
    quantity: 1,
    value,
    currency,
  });
};
